export const getEmployeesAssignedToShiftsButNotInProject = ({
  shifts,
  allProjects,
  allEmployees,
  currentMonth,
  currentYear
}) => {
  if (!shifts || !allProjects || !allEmployees) return [];

  const warningsMap = {};

  const filteredShifts = shifts.filter((shift) => {
    const shiftDate = new Date(shift.date);
    const shiftMonth = shiftDate.getMonth() + 1; // 0-indexed
    const shiftYear = shiftDate.getFullYear();
    return shiftMonth === currentMonth && shiftYear === currentYear;
  });

  filteredShifts.forEach(shift => {
    const project = allProjects.find(p => p._id === shift.project);
    if (!project) return;

    const projectEmployeeIds = Array.isArray(project.employees) ? project.employees : [];

    shift.employees.forEach(emp => {
      const employeeId = emp.employeeId;
      if (!projectEmployeeIds.includes(employeeId)) {
        const key = `${employeeId}_${project._id}`;
        if (!warningsMap[key]) {
          const employee = allEmployees.find(e => e._id === employeeId);
          if (employee) {
            warningsMap[key] = {
              employeeId,
              employeeName: employee.name,
              projectId: project._id,
              projectName: project.name,
              missingShiftCount: 1
            };
          }
        } else {
          warningsMap[key].missingShiftCount += 1;
        }
      }
    });
  });

  return Object.values(warningsMap);
};
